import Hunt from 'huntjs';

export const SetupInViewDetection = (animationTriggers = {}) => {
  const els = document.querySelectorAll('.-detect-in-viewport');
  new Hunt(els, {
    enter: (el) => {
      el.classList.add('-in-viewport');
      if (animationTriggers) {
        for (const triggerSelector in animationTriggers) {
          const triggerFn = animationTriggers[triggerSelector];
          // class on the item itself
          const possibleChildren = el.parentElement.querySelectorAll(triggerSelector);
          if (possibleChildren.length > 0) {
            possibleChildren.forEach((possibleChild) => {
              if (possibleChild === el) {
                triggerFn(possibleChild);
              }
            });
          }
          // selector as child
          if (el.querySelectorAll(triggerSelector).length > 0) {
            el.querySelectorAll(triggerSelector).forEach((el) => {
              triggerFn(el)
            });
          }
        }
      }

      let animatedBlocks = el.querySelectorAll('.animate__animated');

      if (animatedBlocks) {
        animatedBlocks.forEach((animatedBlock) => {
          animatedBlock.classList.add('-start-animation');
        });
      }
    },
  });
};